import { useEffect, useState } from 'react';
import { Input, } from '../../../common/Forms/Input/Input';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  getCorrectDate,
} from '../../../../assets/helpers/funciones';
import {
  paymentType,
  fleetLoadRCVTypes,
} from '../../../../assets/helpers/options';
import { OderCardHeader } from './OrderComponents';
import './OrderComponent.scss';

export const MedCertInfoCard = (props) => {
  const { label, membership, card } = props;
  const { onChange } = card;
  const { register, errors, setValue, watch, control } = card.form;

  const [open, setOpen] = useState(true);


  const preloadForm = () => {
    if (membership?.rcvEndDateFromLastMembership) {
      setValue(
        `rcvEndDateFromLastMembership`,
        getCorrectDate(membership?.rcvEndDateFromLastMembership)
      );
      setValue('rcvEmissionDate', new Date());
      const nextYear = getCorrectDate(membership?.rcvEndDateFromLastMembership);
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      setValue('rcvEndDate', nextYear);
    } else {
      setValue('rcvEmissionDate', new Date());
      setValue('rcvBeginDate', new Date());
      const nextYear = new Date();
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      setValue('rcvEndDate', nextYear);
    }
    setValue('rcvType', fleetLoadRCVTypes?.RCV_BASIC);
  };

  const openRCVModal = () => {
    setValue('billAmount', watch(`amount`));
    setValue('finalPrice', watch(`amount`));
    setValue('finalPriceInBsS', watch(`amountBsS`)); //Monto en Bs en base a euros

    setValue('paymentMethodsQuantity', 1);
    setValue('paymentType', paymentType?.DE_CONTADO);
    setValue('amount0', watch(`amount`));
    setValue('amountBsS0', watch('finalPriceInBsS')); //Monto en Bs en base a euros
  };

  const handlePaymentDateChange = () => {
    onChange?.getPaymentDateRate();
  };

  useEffect(() => {
    Promise.allSettled([preloadForm()]).then((r) => {
      setTimeout(() => { }, 1500);
    });
    // preloadKm()
  }, [open]);

  return (
    <>
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              <div style={{ width: '100%' }} className="row">
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL CLIENTE
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Certificado Médico *'}
                      type={'select'}
                      options={[
                        {
                          _id: true,
                          name: 'Si',
                        },
                      ]}
                      noBlankOption={true}
                      name={'useMedCert'}
                      register={register}
                      placeholder={''}
                      errors={errors?.useMedCert?.message}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL PAGO
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Fecha de Pago *'}
                      type={'birthday'}
                      name={'paymentDate'}
                      register={register}
                      capitalizeOff={true}
                      placeholder={''}
                      control={control}
                      errors={errors?.paymentDate?.message}
                      onChange={() => handlePaymentDateChange()}
                    />
                    <>
                      <Input
                        bootstrap={'col-12 '}
                        label={`Monto USD * Tasa:${card.dollarRate} Bs`}
                        type={'number'}
                        name={'amount'}
                        register={register}
                        placeholder={''}
                        errors={errors?.amount?.message}
                        min={'0'}
                        disabled={true}
                      />
                      <Input
                        bootstrap={'col-12 '}
                        label={'Monto BsS *'}
                        type={'number'}
                        name={'amountBsS'}
                        register={register}
                        placeholder={''}
                        errors={errors?.amountBsS?.message}
                        disabled={true}
                      />
                      {watch('amount') &&
                        watch('amountBsS') &&
                        !watch('paymentMethodsQuantity') && (
                          <div className="buttons-center-container">
                            <ActionButton
                              label={'Pagar'}
                              action={() => openRCVModal()}
                            />
                          </div>
                        )}
                    </>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
